import { Menu, MenuItem } from "@mui/material";
import type { Job } from "../../utils/models";

type EditJobPopoverProps = {
	currentJobId: string;
	availableJobs: Job[];
	onJobChange: (newJobId: string) => void;
	onClose: () => void;
	anchorEl: HTMLElement | null;
};

export const EditJobPopover = ({ currentJobId, availableJobs, onJobChange, onClose, anchorEl }: EditJobPopoverProps) => {
	return (
		<Menu
			open={true}
			onClose={onClose}
			anchorEl={anchorEl}
			anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
			transformOrigin={{ vertical: "top", horizontal: "left" }}
		>
			{availableJobs.map((job) => (
				<MenuItem key={job.id} onClick={() => onJobChange(job.id)} selected={job.id === currentJobId} sx={{ fontSize: "14px" }}>
					{job.displayName}
				</MenuItem>
			))}
		</Menu>
	);
};
